import styled, { css } from "styled-components";
import { IStyleProps } from "./interfaces";

export const Svg = styled.svg<IStyleProps>`
    fill: ${p => p.theme.c.active};
    ${p =>
        p.margin &&
        css`
            display: block;
            margin: ${p.margin};
        `};
`;
